import Card from "react-bootstrap/Card";
import Mana from "./Mana";
import PropTypes from "prop-types";
import React from "react";
import Spinner from "./Spinner";
import classNames from "classnames";
import reactStringReplace from "react-string-replace";
import styles from "../styles/Description.module.scss";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { v4 } from "uuid";

const Container = ({ children }) => {
  const { dir, subpage } = useParams();
  return (
    <div className={styles.container}>
      <Card className={classNames(styles.comboDescription, "shadow-sm")}>
        {dir === "combos" && subpage && <Card.Header as="h5">Combo Explained</Card.Header>}
        <Card.Body className={styles.description}>{children}</Card.Body>
      </Card>
    </div>
  );
};

Container.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

const Description = ({ children }) => {
  const { dir } = useParams();
  const { isLoading } = useSelector((state) => state.pagedata);

  if (isLoading && !["cards", "commanders"].includes(dir)) {
    return (
      <Container>
        <div className={styles.spinner}>
          <Spinner className="fa-3x" />
        </div>
      </Container>
    );
  } else if (!children) {
    return null;
  } else {
    return (
      <Container>
        {(Array.isArray(children) ? children : [children])
          .map((child) =>
            React.isValidElement(child)
              ? child
              : reactStringReplace(
                  child.replace(/::/g, ":&#8203;:"),
                  /(:[^:\s]*(?:::[^:\s]*)*:)/,
                  (match) => {
                    const name = match.substring(1, match.length - 1);
                    return <Mana className="emote" color={name.replace("mana", "")} />;
                  }
                )
          )
          .map((child) =>
            Array.isArray(child)
              ? child.map((elem) =>
                  React.isValidElement(elem) ? (
                    React.cloneElement(elem, { key: v4() })
                  ) : (
                    <span key={v4()} dangerouslySetInnerHTML={{ __html: elem }} />
                  )
                )
              : React.isValidElement(child)
              ? React.cloneElement(child, { key: v4() })
              : null
          )}
      </Container>
    );
  }
};

Description.propTypes = {
  children: PropTypes.string,
};

export default Description;
